import { Button } from 'core-components/library/button'
import { useProcessLogin } from 'src/core/layout/login/hooks'

export const LoginButton = () => {
  const { initiateLogin, isLoginProcessing } = useProcessLogin()

  return (
    <Button onClick={initiateLogin} loading={isLoginProcessing}>
      Login
    </Button>
  )
}
